import { TASK_CODES } from "../components/forms/Form4CarePlan";
import { TASKS } from "../components/forms/FunctionalForm";
import { AREAS } from "../components/forms/EnvironmentalForm";

export const demoIntake = {
  full_name: "Harold Jennings",
  dob: "1944-01-28",
  service_address: "88 Maple St, Scranton, PA 18505",
  county: "Lackawanna",
  primary_phone: "570-555-0102",
  can_text: "Yes",
  email: "hjennings@example.com",
  preferred_communication: "Phone call",
  preferred_language: "English",
  has_legal_rep: "Yes",
  rep_type: "POA",
  rep_name: "Maria Jennings",
  rep_relationship: "Daughter",
  rep_phone: "570-555-0113",
  rep_email: "maria.j@example.com",
  directs_own_care: "Yes",
  primary_contact_type: "Authorized Representative",
  pc_name: "",
  pc_relationship: "",
  pc_phone: "",
  pc_email: "",
  ec_name: "Maria Jennings",
  ec_relationship: "Daughter",
  ec_phone: "570-555-0113",
  ec_email: "maria.j@example.com",
  payer: "CHC",
  mco_name: "Keystone First",
  medicaid_id: "PA-88213467",
  mco_member_id: "KF-554210",
  coordinator_name: "Dana Whitfield",
  coordinator_phone: "570-555-0177",
  coordinator_email: "dwhitfield@mco.example.com",
};

export const demoProfile = {
  assessment_date: "2026-08-07",
  completed_by: "Kelly R.",
  assessment_type: "New admission",
  lives_alone: "Yes",
  who_lives_in_home: "",
  under_18: "No",
  home_type: "Single Family",
  floor_level: "First Floor",
  stairs_affecting_care: "No",
  entry_instructions: "Use garage door; knock loudly",
  lockbox_code: "4417",
  parking_instructions: "Driveway",
  pets: "Yes",
  pet_details: "Small dog (Buddy) — friendly, underfoot near entry",
  smoking_inside: "No",
  weapons_in_home: "No",
  weapons_storage: "",
  private_rooms: "Wife's sewing room is off-limits",
  other_safety_concern: "Oxygen tubing crosses floor at night",
  primary_diagnoses: "COPD, type 2 diabetes, left-side weakness post-stroke — affects stamina, grip, and balance",
  allergies: "None",
  allergy_details: "",
  recent_falls: "No",
  fall_details: "",
  recent_hospitalization: "Yes",
  hospitalization_details: "Stroke admission 14 months ago",
  mobility_status: "Ambulatory with cane; drags left foot when tired",
  assistive_devices: "Cane, spare walker, O2 concentrator at night",
  cognitive_concerns: "Yes",
  cognitive_details: "Mild aphasia when fatigued; forgets insulin timing",
  behavioral_concerns: "No",
  behavioral_details: "",
  communication_limitations: "Yes",
  communication_details: "Word-finding difficulty when tired — give him time to respond",
  other_health_info: "",
  physician_name: "Dr. Chen",
  physician_phone: "570-555-0140",
  pharmacy_name: "Maple Pharmacy",
  pharmacy_phone: "570-555-0188",
  hospice: "No",
  hospice_provider: "",
  skilled_nursing: "Yes",
  skilled_nursing_provider: "Heritage Home Health — nurse Rosa 570-555-0120",
};

export const demoSurvey = {
  medical_conditions:
    "COPD, type 2 diabetes, left-side weakness post-stroke (2025). Tires quickly, drags left foot when fatigued, short of breath in humidity.",
  medications_count: "10",
  medications_org: "Pharmacy blister packs (morning/evening); insulin pens in fridge",
  compliance_challenges:
    "Confused by insulin timing; skips glucose checks when 'feeling fine'; once doubled a dose after forgetting he had taken it.",
  living_situation: "Lives alone in single-story ranch home",
  time_alone: "Alone evenings and weekends",
  support_network: "Daughter 20 minutes away; neighbor checks in most mornings",
  family_involvement: "Daughter Maria calls daily and visits weekends; manages bills",
  recent_life_changes:
    "Stroke 14 months ago; gave up driving; wife Rosa moved to memory care 6 months ago after 54 years of marriage",
  mental_health: "Low mood since wife's move; on waitlist for grief counseling",
  personal_background: "Retired railroad engineer of 38 years; married 54 years; proud of his workshop",
  important_people: "Wife Rosa, daughter Maria, son Paul, dog Buddy",
  what_matters: "Visiting Rosa weekly, staying independent in his home, time in his workshop",
  routines: "Up at 6am, coffee and the news, lunch at noon, nap after lunch, early bed",
  enjoyments: "Model trains, Pirates baseball, woodworking, visits with Rosa",
  good_days: "Sees Rosa, breathing is easy, gets time in the workshop",
  difficult_days: "Humid days make breathing hard; lonely evenings; misses Rosa most at dinner",
  strengths: "Determined, mechanically minded, dry sense of humor",
  goals: "Walk to his workshop unaided; visit Rosa every week; stay in his home",
};

const FUNC = {
  "Meal Preparation": [3, "Daily lunch", "Cannot stand long at stove; left hand grip weak"],
  Housework: [3, "Weekly", "Short of breath with exertion"],
  Finances: [2, "", "Daughter helps with bills; writes checks slowly"],
  Medications: [3, "Daily AM/PM", "Insulin timing confusion; blister packs otherwise fine"],
  Shopping: [4, "Weekly", "No longer drives"],
  Transportation: [4, "As needed", "Relies on daughter for appointments"],
  Hygiene: [2, "Daily", "Slow but willing"],
  "Dressing - Upper Body": [3, "Daily", "Left arm weakness makes buttons hard"],
  "Dressing - Lower Body": [3, "Daily", "Balance risk when bending"],
  Locomotion: [2, "Ongoing", "Uses cane; drags left foot when tired"],
  Transfers: [2, "Ongoing", "Needs moment to steady after standing"],
  "Toilet Use": [1, "", "Independent, occasional urgency"],
  "Bed Mobility": [1, "", "Slow repositioning"],
  Eating: [0, "", "Independent"],
  "Bladder Incontinence": [1, "", "Occasional urgency, no accidents reported"],
  "Bowel Incontinence": [0, "", ""],
  "Personal Care": [2, "Daily", "Needs reminders some mornings"],
  "Bathing - Wash-up": [1, "Daily", "Independent at sink"],
  "Bathing - Shower": [3, "M/W/F", "Needs bench and standby assist; no grab bars"],
  "Lotion Application": [0, "", ""],
  Laundry: [3, "Weekly", "Carrying basket is difficult"],
  "Reading/Writing": [1, "", "Wears glasses; mild aphasia when tired"],
  "Supervision - Daytime": [2, "Weekdays", "Oxygen use and glucose monitoring"],
  "Supervision - Nighttime": [1, "", "Generally sleeps through; O2 concentrator runs"],
};

export const demoFunctional = {
  assessor: "Kelly R.",
  assessment_date: "2026-08-06",
  general_notes:
    "Post-stroke left-sided weakness; COPD exacerbation risk in humidity; O2 concentrator in bedroom with tubing across walkway at night. Watch glucose monitoring consistency.",
  tasks: TASKS.map((name) => {
    const [level, days_times, notes] = FUNC[name] || [0, "", ""];
    return { name, level, days_times, notes };
  }),
};

const ENV = {
  exterior: { Steps: ["Concern", "3 front steps, rail on left only"], Handrails: ["Concern", "Single rail; loose at bottom"], Lighting: ["OK", ""], Thresholds: ["OK", ""] },
  interior: { Cleanliness: ["OK", ""], "Trip Hazards": ["Hazard", "O2 tubing across floor at night; area rugs in den"], Clutter: ["OK", ""], Lighting: ["Concern", "Den is dim"], "Smoke Detectors": ["OK", "Tested working"] },
  bathroom: { "Tub Type": ["Concern", "Walk-in shower, no bench"], "Grab Bars": ["Hazard", "None in shower"], "Floor Surfaces": ["Concern", "Tile slippery when wet"], "Toilet Height": ["OK", "Comfort height"] },
  bedroom: { "Bed Height": ["OK", ""], "Path to Bathroom": ["Concern", "O2 tubing crosses walkway"], Nightlights: ["Concern", "Only one, in bathroom"], "Medical Equipment": ["Concern", "O2 concentrator; tubing clutter"] },
  kitchen: { "Stove Safety": ["Concern", "Electric; left burner on once last month"], Accessibility: ["OK", ""], "Expired Food": ["OK", ""], "Fire Hazards": ["OK", ""] },
  storage: { "Medication Storage": ["Concern", "Insulin pens loose in fridge door among food"], "Equipment Storage": ["OK", "Concentrator has clear space"] },
  clinical: { "Moving Around the Home": ["Concern", "Cane; left foot drag when fatigued"], "Memory & Conversation": ["OK", "Mild aphasia when tired; oriented"], "Mood & Outlook": ["Concern", "Flat affect when discussing wife"], "Personal Care Routines": ["OK", ""], "Daily Activity Concerns": ["Concern", "Left grip weak; some ankle swelling"] },
};

export const demoEnvironmental = {
  assessor: "Kelly R.",
  assessment_date: "2026-08-06",
  overall_risk: "Moderate",
  equipment_recommendations:
    "Shower bench, grab bars in shower, O2 tubing management clips/cord covers, extra nightlights on bedroom-to-bathroom path, ramp evaluation for front steps",
  summary_notes:
    "Single-story ranch. Oxygen concentrator in bedroom; tubing crosses the nighttime path to the bathroom. Dog is friendly but underfoot near entry.",
  areas: Object.fromEntries(
    AREAS.map((a) => [a.key, a.items.map((name) => ({ name, status: ENV[a.key]?.[name]?.[0] || "OK", note: ENV[a.key]?.[name]?.[1] || "" }))])
  ),
};

export const demoMedications = {
  date_reviewed: "2026-08-07",
  entries: [
    { name: "Metformin", dosage: "500mg", frequency: "2x daily" },
    { name: "Lisinopril", dosage: "10mg", frequency: "1x daily (AM)" },
    { name: "Furosemide", dosage: "20mg", frequency: "1x daily (AM)" },
    { name: "Insulin glargine", dosage: "12 units", frequency: "Evening" },
    { name: "Albuterol inhaler", dosage: "90mcg", frequency: "As needed" },
  ],
  notes: "Blister packs from pharmacy; insulin pens in fridge door.",
  source: "Medication containers reviewed",
  source_other: "",
};

const demoLevels = { "115": ["Hands On"], "116": ["Complete"], "118": ["Remind"], "120": ["Complete"], "122": ["Supervise"], "123": ["Stand By"], "124": ["Stand By"], "135": ["Stand By", "Hands On"], "140": ["Supervise"] };

export const demoCareplan = {
  effective_date: "2026-08-12",
  auth_start: "2026-08-12",
  auth_end: "2027-08-11",
  authorized_hours: "20",
  hours_period: "Week",
  supervisor: "Patti C.",
  caregivers: "TBD at staffing",
  need: "Weekday support with meals, light housekeeping, bathing, medication reminders, and rides to appointments and to visit his wife.",
  goal: "Harold wants to stay in his own home, keep his morning routine, and visit Rosa every week.",
  schedule: {
    Monday: { start: "09:00", end: "13:00" }, Tuesday: { start: "09:00", end: "13:00" },
    Wednesday: { start: "09:00", end: "13:00" }, Thursday: { start: "09:00", end: "13:00" },
    Friday: { start: "09:00", end: "13:00" },
  },
  total_weekly_hours: "20.0",
  schedule_instructions: "Arrive by 9am; Harold naps after lunch — quieter tasks in the afternoon.",
  tasks: TASK_CODES.map((t) => ({
    ...t,
    selected: Object.keys(demoLevels).includes(t.code),
    levels: demoLevels[t.code] || [],
    frequency: t.code === "118" ? "Daily AM/PM" : t.code === "120" ? "As needed" : "Each visit",
    instruction: t.code === "135" ? "Use shower bench; he is steadier mid-morning" : "",
  })),
  med_box_location: "Kitchen counter, blister packs; insulin in fridge door",
  reminder_times: "9am and before leaving at 1pm",
  reminder_instructions: "Point to the blister pack compartment; never hand him insulin — reminders only",
  med_refused_action: "Note it, don't press; call the office if he refuses two days in a row",
  transport_approved: "Yes",
  transport_vehicle: "Caregiver vehicle",
  transport_instructions: "Approved trips only; he sits in front seat; no highway driving",
  equipment_used: "Cane; gait belt in hall closet",
  transfer_instructions: "Let him stand on his own count; steady, don't lift",
  routines_preferences: "Coffee and news at 7am; call him Harold, never 'sweetie'; Pirates games are sacred",
  off_limits: "Wife's sewing room stays closed",
  safety_instructions: "Watch O2 tubing on the floor at night; Buddy the dog is underfoot near the entry",
  backup_options: ["Silver may offer another qualified caregiver", "Contact client/primary contact before sending replacement"],
  backup_instructions: "Maria (daughter) must approve any substitute caregiver",
};

export const demoApproval = {
  version: "v1",
  effective_date: "2026-08-12",
  reviewed_with_client: "Yes",
  rep_participated: "Yes",
  changes_requested: "No",
  changes_completed: "",
  signer_type: "",
  client_signature_date: "",
  client_signature_png: null,
  agency_rep: "",
  agency_signature_date: "",
  agency_signature_png: null,
  status: "Draft",
};

export const demoGty = {
  anything_else: "He lights up talking about the railroad. Sunday calls with Katie are the highlight of his week.",
  guided_answers: {},
};

export const DEMO = {
  intake: demoIntake,
  profile: demoProfile,
  gty: demoGty,
  medications: demoMedications,
  careplan: demoCareplan,
  approval: demoApproval,
};
